import './main';
import { debounce } from '../utils.js';
import { v4 as uuidv4 } from 'uuid';

const project = process.env.SLS_PROJECT; // process.env.SLS_PROJECT;
const host = process.env.SLS_HOST; // 'aliyuncs.com';
const logstore = process.env.SLS_LOGSTORE; // web_poster_logs/track.gif;
const logstoreCustom = process.env.SLS_LOGSTORE_CUSTOM; // web-logs/track_ua.gif;
const version = process.env.SLS_VERSION;

var timestamp = {
  page_view: new Date().getTime(),
  render_over: 0,
  resouce_over: 0,
  page_enter: 0, // 页面显示/初始进入
  page_time: 0, // 页面隐藏/关闭
};
// 元素展示停留时长
var section_timestamp = {
  section_enter: new Date().getTime(), //界面进入
  section_leave: 0, // 界面离开
};

function i() {
  if (typeof window === 'undefined') return;
  (function (window, document) {
    function LogTracker(host, project, logstore) {
      this.uri_ =
        'https://' +
        project +
        '.' +
        host +
        '/logstores/' +
        logstore +
        '?APIVersion=0.6.0';
      this.params_ = [];
    }
    LogTracker.prototype = {
      push: function (key, value) {
        if (!key || value === null || value === '' || value === undefined) {
          return;
        }
        this.params_.push(key);
        this.params_.push(value);
      },
      logger: function () {
        var url = this.uri_;
        var k = 0;
        while (this.params_.length > 0) {
          if (k % 2 == 0) {
            url += '&' + encodeURIComponent(this.params_.shift());
          } else {
            url += '=' + encodeURIComponent(this.params_.shift());
          }
          ++k;
        }
        var img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.src = url;
      },
    };
    window.Tracker = LogTracker;
  })(window, document);
}
i();

function getQuery(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
function TrackerCommonField(_tracker, action) {
  // action 事件
  _tracker.push('action', action);
  // G-UA 浏览器UA
  _tracker.push('G-UA', navigator.userAgent);
  // G-REFER 前向url地址
  _tracker.push('G-REFERER', document.referrer);
  // G-URL 当前页地址
  _tracker.push('G-URL', window.location.href);
  // xua: uuid + version 建站器版本 + t + c
  let xua = 'uuid=' + window.moo.uuid + '&version=' + version;
  if (getQuery('t')) {
    xua += '&ch=' + getQuery('t');
  }
  if (getQuery('c')) {
    xua += '&c=' + getQuery('c');
  }
  _tracker.push('xua', xua);
  // timestamp 行为触发时间戳
  let _time = new Date().getTime();
  _tracker.push('timestamp', _time);
  _tracker.push('title', document.title);
  _tracker.push('tap_app_id', window.moo.app_id);
  _tracker.push('code', window.moo.code);

  if (action !== 'page_view') timestamp[action] = _time;

  if (action === 'page_view') {
    timestamp.page_enter = _time; // 进入页面时间，统计停留时长
    localStorage?.setItem('page_enter', _time);
  }
}

//extra 里面加上默认参数
function makeProperties(extra) {
  return {
    ...extra,
    ...(window.moo?.tracker?.defaultExt || {}),
  };
}
function TrackerLogger(action, callback) {
  let tracker = new window.Tracker(host, project, logstore);
  TrackerCommonField(tracker, action);

  // 传入callback，可额外手动push参数后，再logger
  if (callback) {
    callback(tracker);
  } else {
    tracker.logger();
  }
}
function customTrackerLogger(action, callback) {
  let tracker = new window.Tracker(host, project, logstoreCustom);
  TrackerCommonField(tracker, action);

  // 传入callback，可额外手动push参数后，再logger
  if (callback) {
    callback(tracker);
  } else {
    tracker.logger();
  }
}

function init() {
  if (typeof window === 'undefined') return;
  if (!window.moo) {
    window.moo = {};
  }
  window.moo.uuid = localStorage?.getItem('uuid') || uuidv4(); // window.uuidv4();
  localStorage?.setItem('uuid', window.moo.uuid);
  // console.log('init tracker');
  // 1、访问页面
  TrackerLogger('page_view', (tracker) => {
    tracker.push('extra', JSON.stringify(makeProperties()));
    tracker.logger();
  });
  setTimeout(() => {
    // 2、渲染完成后触发（需要用户看到页面元素）
    TrackerLogger('render_over', (tracker) => {
      // duration (单位s)
      let duration = Number(
        ((timestamp.render_over - timestamp.page_view) / 1000).toFixed(4)
      );
      tracker.push('duration', duration);
      tracker.push('extra', JSON.stringify(makeProperties()));
      tracker.logger();
      // console.log('render_over', tracker.params_);
    });
  }, 0);
  // 3、资源加载成功
  document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
      TrackerLogger('resouce_over', (tracker) => {
        // duration (单位s)
        let duration = Number(
          ((timestamp.resouce_over - timestamp.page_view) / 1000).toFixed(4)
        );
        tracker.push('duration', duration);
        tracker.push('extra', JSON.stringify(makeProperties()));
        tracker.logger();
        // console.log('resouce_over', tracker.params_);
      });
    }
  };
  // 4、页面停留时长
  // 隐藏页面 - 进入后台/页签切换
  document.addEventListener('visibilitychange', function () {
    if (window.$trackCustomEvent) return;
    if (document.hidden) {
      // 隐藏页面
      TrackerLogger('page_time', (tracker) => {
        // duration (单位s)
        let duration = Number(
          ((timestamp.page_time - timestamp.page_enter) / 1000).toFixed(4)
        );
        tracker.push('duration', duration);
        tracker.push('extra', JSON.stringify(makeProperties()));
        tracker.logger();
        // console.log('page_time', tracker.params_);
      });
      // 统计跳出位置
      leavePage();
      // 界面曝光
      // lengthOfStay();
    } else {
      // 显示页面
      let _time = new Date().getTime();
      timestamp.page_enter = _time;
      section_timestamp.section_enter = _time;
    }
  });
  // 关闭页面
  // window.onunload = function() {};
}
init();

function tapTapTrackerLogger(param) {
  const posterData = {
    title: document.title, // 网页标题
    code: window.moo.code, // 页面编码
    uuid: window.moo.uuid, // 网页唯一身份 ID
    tap_app_id: window.moo.app_id, // Tap APP ID
  };
  if (param['extra']) {
    let temp = JSON.parse(param['extra']);
    temp['poster'] = posterData;
    param['extra'] = temp; // JSON.stringify(temp);
  } else {
    param.extra = {
      poster: posterData,
    };
  }
  if (param['ctx']) {
    let temp = JSON.parse(param['ctx']);
    temp['uri'] = window.location.href;
    param['ctx'] = JSON.stringify(temp);
  } else {
    param['ctx'] = {
      uri: window.location.href,
    };
  }
  if (window.moo.TAPTAP?.IS_INTL) {
    //tap海外web端默认上报booth:webview
    param['booth'] = 'webview';
  }
  window.$trackCustomEvent({
    customParam: param,
  });
}

// 点击
function click(object_type, object_id, extra) {
  // if (!TrackerLogger) return;
  if (window.$trackCustomEvent) {
    let param = {
      action: 'click',
      object_type: object_type,
      object_id: object_id,
      extra: JSON.stringify(makeProperties(extra)),
    };
    tapTapTrackerLogger(param);
    return;
  }
  extra.device = {
    IS_ANDROID: window.moo.CONSTANT.IS_ANDROID,
    IS_IOS: window.moo.CONSTANT.IS_IOS,
  };
  TrackerLogger('click', (tracker) => {
    tracker.push('object_type', object_type);
    tracker.push('object_id', object_id);
    tracker.push('extra', JSON.stringify(makeProperties(extra)));
    tracker.logger();
  });
}

// 用户自助埋点
function custom(action, object_type, object_id, extra, other = {}, isTapTap) {
  if (typeof window === 'undefined') return;
  let param = {
    action: action,
    object_type: object_type,
    object_id: object_id,
    extra: JSON.stringify(makeProperties(extra)),
  };
  if (other) {
    Object.keys(other).map((i) => {
      let v = JSON.stringify(other[i]);
      if (typeof v === Object) v = JSON.stringify(v);
      param[i] = v;
    });
  }

  // isTapTap 这个判断暂时保留，这里现阶段需要手动加入一个 tap 远程组件，按理说应该从入口文件开始就是已经自带这个函数了。
  // TODO 等 Tap 基础库更新。
  if (window.$trackCustomEvent) {
    tapTapTrackerLogger(param);
    return;
  }
  customTrackerLogger(action, (tracker) => {
    Object.keys(param).forEach((key) => {
      if (key != 'action') {
        tracker.push(key, param[key]);
      }
    });
    tracker.logger();
  });
}

function stayTrack(type, id, extra) {
  // section_timestamp.section_leave = new Date().getTime();

  TrackerLogger('stay', (tracker) => {
    tracker.push('object_type', type);
    tracker.push('object_id', id);
    tracker.push('extra', JSON.stringify(makeProperties(extra)));
    tracker.logger();
    // section_timestamp.section_enter = section_timestamp.section_leave;
  });
}

function viewTrack(type, id, extra) {
  if (window.$trackCustomEvent) {
    let param = {
      action: 'view',
      object_type: type,
      object_id: id,
      extra: JSON.stringify(makeProperties(extra)),
    };
    tapTapTrackerLogger(param);
    return;
  } else {
    // 最早的曝光展示优于远程组件加载
    let remoteEls = document.getElementsByClassName(
      'CustomTapGlobalDefaultComponent'
    );
    if (remoteEls) {
      setTimeout(() => {
        viewTrack(type, id, extra);
      }, 500);
      return;
    }
  }
  TrackerLogger('view', (tracker) => {
    tracker.push('object_type', type);
    tracker.push('object_id', id);
    tracker.push('extra', JSON.stringify(makeProperties(extra)));
    tracker.logger();
  });
}

function fissionTrack(callback) {
  /** 裂变统计
   * A -> B, B打开页面，算第1次裂变; B -> C, C打开页面算第2次裂变
   * 通过地址栏传递f参数，来判断当前裂变处在哪个环节
   * 只计算首次裂变链路（查到本地有裂变字段就return）
   */
  if (typeof window === 'undefined' || !window.localStorage) return;

  let params = new URL(window.location.href).searchParams;
  let v = params.get('f');

  let fissionKey = (window.moo.code || 'locale') + '-fission';
  let local_level = JSON.parse(localStorage.getItem(fissionKey));
  if (!local_level) {
    // 本地无缓存
    let pre_fission_level = 0;
    if (v && !isNaN(Number(v))) {
      pre_fission_level = Number(v);
    }

    let fission_level = pre_fission_level + 1;
    // 开始上报
    TrackerLogger('view', (tracker) => {
      tracker.push('object_id', 'share');
      tracker.push(
        'extra',
        JSON.stringify(makeProperties({ share_level: fission_level }))
      );
      tracker.logger();
    });

    localStorage.setItem(fissionKey, JSON.stringify(fission_level));
    callback('f', fission_level);
  } else {
    // 本地有缓存
    if (!v) {
      callback('f', JSON.parse(local_level));
    }
  }
}

// 统计跳出位置
function leavePage() {
  const DomContainer = document.getElementsByClassName(
    'widget-frame-primary'
  )[0];

  let height_container = DomContainer.offsetHeight;
  let height_client = document.documentElement.clientHeight;
  let height_scroll = DomContainer.getBoundingClientRect().top;

  let proportion = (height_client + Math.abs(height_scroll)) / height_container;
  let leave_at = Number(proportion.toFixed(2));

  TrackerLogger('leave', (tracker) => {
    tracker.push('object_id', '');
    tracker.push(
      'extra',
      JSON.stringify(makeProperties({ leave_at: leave_at }))
    );
    tracker.logger();
  });
}

// 预约成功 将废弃
function reserve(object_type, object_id) {
  // if (!TrackerLogger) return;
  TrackerLogger('reserve', (tracker) => {
    tracker.push('object_type', object_type);
    tracker.push('object_id', object_id);
    tracker.logger();
  });
}

// 跳转到google登录 将废弃
function redirect() {
  // if (!TrackerLogger) return;
  TrackerLogger('redirect');
}

// google登录成功 将废弃
function callback() {
  // if (!TrackerLogger) return;
  TrackerLogger('callback');
}

export {
  click,
  reserve,
  redirect,
  callback,
  viewTrack,
  debounce,
  custom,
  fissionTrack,
  stayTrack, // 统计元素浏览停留时长
};
